<template>
  <div>
    <p style="text-align: center">
      <span class="systemFont1">{{ $t("p0322.classInvitation") }}</span>
    </p>
    <el-row style="top: 17px">
      <!-- 模糊查询 -->
      <div style="display: inline-block;">
        <el-form
          :model="queryForm"
          label-position="right"
          ref="queryForm"
          label-width="80px"
          class="systemFont1"
        >
          <!-- 课程名称 -->
          <div style="width:300px;display: inline-block; float:left;">
            <el-form-item :label="$t('p0331.courseTitle')">
              <el-input
                name="queryForm.courseName"
                type="text"
                v-model="queryForm.courseName"
                clearable
                :placeholder="$t('p0331.courseTitle')"
              ></el-input>
            </el-form-item>
          </div>
          <div style="width:40px;display:inline-block; float:left;">
            &nbsp;&nbsp;
          </div>
          <!-- 上课时间 -->
          <div style="width:430px;display:inline-block; float:left;">
            <el-form-item :label="$t('p0331.classTime')">
              <el-date-picker
                v-model="queryForm.dateAndTime"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <div style="width:40px;display:inline-block; float:left;">
            &nbsp;&nbsp;
          </div>
          <!-- 课程状态 -->
          <div style="width: 200px;display:inline-block;float:left;">
            <el-form-item :label="$t('p0321.courseStatus')">
              <el-select
                v-model="queryForm.scheduleStatus"

                style="width: 100%"
                :placeholder="$t('p0321.courseStatus')"
                clearable
              >
                <el-option
                  v-for="item in scheduleStatusOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div
            style="width:70px;height:100%;display: inline-block; float:left;"
          >
            <img
              src="../../assets/query2.svg"
              width="36px"
              height="36px"
              style="cursor: pointer;"
              @click="init(true)"
            />
          </div>
        </el-form>
      </div>
      <el-col :span="22" :offset="1">
        <el-row><br /></el-row>
      </el-col>
    </el-row>
    <el-row style="top: 17px">
      <el-col :span="22" :offset="1">
        <el-table
          :data="classInvitationData"
          style="width: 100%; margin-bottom: 75px"
        >
          <el-table-column
            prop="field"
            :label="$t('courseOption.field')"
            align="left"
            min-width="50"
          >
          </el-table-column>
          <el-table-column
            prop="category"
            :label="$t('courseOption.category')"
            align="left"
            min-width="40"
          >
          </el-table-column>
          <!-- 编号 -->
          <el-table-column
            :formatter="valueFormat"
            :label="$t('courseOption.number')"
            align="left"
            min-width="60"
          >
          </el-table-column>
          <!-- 形式 -->
          <el-table-column
            prop="form"
            :label="$t('courseOption.form')"
            align="left"
            min-width="40"
          >
          </el-table-column>
          <el-table-column
            prop="courseName"
            :label="$t('courseOption.courseName')"
            align="left"
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            prop="dateAndTime"
            :label="$t('p0331.classTime')"
            align="left"
            min-width="85"
          >
            <template slot-scope="scope">
              {{
                scope.row.formCode == "02"
                  ? $t("p0322.unlimited")
                  : scope.row.dateAndTime
              }}
            </template>
          </el-table-column>
          <!-- 状态 -->
          <el-table-column
            prop="scheduleStatus"
            :label="$t('p0321.status')"
            align="center"
            width="55px"
          >
            <template slot-scope="scope">
            <span
              v-if="scope.row.status === '1'"
              style="color: #f56c6c;"
            >{{ $t("p0322.suspended") }}
            </span>
              <span
                v-else-if="scope.row.scheduleStatus !== 1"
                style="color: #f56c6c;"
              >{{ $t("p0321.postponement") }}</span
              >
              <span v-else-if="scope.row.scheduleStatus === 1">{{
                  $t("p0321.normal")
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('common.operation')"
            align="center"
            min-width="170"
          >
            <template slot-scope="scope">
              <el-button @click="editClass(scope.row)" type="text">{{
                $t("p0322.editClassSchedule")
              }}</el-button>
              <!-- 去邀请 -->
              <el-button
                v-if="scope.row.scheduleStatus === 1 && scope.row.status !== '1'"
                @click="invite(scope.row)"
                type="text"
                >{{ $t("p0322.invite") }}</el-button
              >
              <el-button
                v-if="scope.row.scheduleStatus === 2 && scope.row.status !== '1'"
                @click="invite(scope.row)"
                type="text"
                >{{ $t("p0321.registered") }}</el-button
              >
              <!-- 报名二维码 -->
              <el-button
                v-if="scope.row.scheduleStatus === 1  && scope.row.status !== '1'"
                @click="downloadQrCode(scope.row)"
                type="text"
                >{{ $t("p0322.qrCode") }}</el-button
              >
              <!-- 延期 -->
              <el-button
                v-if="scope.row.scheduleStatus === 1&& scope.row.status !== '1'"
                @click="handleExtension(scope.row)"
                type="text"
                >{{ $t("p0321.postponement") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: right; margin: 20px">
          <el-col :span="24">
            <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPageCo"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSizeCo"
                layout="total, sizes, prev, pager, next"
                :total="totalCo"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      scheduleStatusOption: [
        { value: 1, label: this.$t("p0433.normal") },
        { value: 2, label: this.$t("p0321.postponement") },
        { value: 3, label: this.$t("p0321.suspended") }
      ],
      // 上课邀请一览数据
      classInvitationData: [],
      // 查询条件
      queryForm: {
        courseName: "",
        dateAndTime: "",
        scheduleStatus: undefined
      },
      // 当前页
      currentPageCo: 1,
      // 每页件数
      pageSizeCo: 10,
      totalCo: 0
    };
  },
  watch: {
    // 监听上课时间区段
    "queryForm.dateAndTime"(newVal) {
      if (newVal == null) {
        this.queryForm.dateAndTime = [];
        this.init(true);
      }
    },
    // 监听课程名称是否为空
    "queryForm.courseName"(newVal) {
      if (newVal == "") {
        this.queryForm.courseName = "";
        this.init(true);
      }
    },
    // 监听课程名称是否为空
    "queryForm.scheduleStatus"(newVal) {
      if (newVal == "") {
        this.queryForm.scheduleStatus = "";
        this.init(true);
      }
    }
  },
  methods: {
    // 每页数据条数设定
    handleSizeChange(val) {
      this.pageSizeCo = val;
      this.currentPageCo = 1;
      //判断更改页码是否需要查询
      if (
        this.classInvitationData == undefined ||
        this.classInvitationData.length <= 0
      ) {
        return;
      }
      this.init(false);
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPageCo = val;
      this.init(false);
      // console.log(`当前页: ${val}`);
    },
    // 初始化上课邀请一览数据
    init(val) {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      if (val) {
        // 分页数据初始化
        this.currentPageCo = 1;
        this.totalCo = 0;
      }
      let url = "/api/classInvitation/ClassInvitationByPage";
      this.$http
        .post(url, {
          scheduleStatus: this.queryForm.scheduleStatus,
          //课程名称模糊查询
          selectCourseName: this.queryForm.courseName,
          // 开始日期
          startDate: this.queryForm.dateAndTime[0],
          // 截止日期
          endDate: this.queryForm.dateAndTime[1],
          // 当前页
          currentSizeCo: (this.currentPageCo - 1) * this.pageSizeCo,
          // 页数
          pageSizeCo: this.pageSizeCo,
          // 总数
          totalCo: this.totalCo
        })
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            // 判断有没有数据
            if (response.data.data == null) {
              this.classInvitationData = [];
            } else {
              // 总数取值
              this.totalCo = response.data.data[0].totalCo;
              // 渲染页面
              this.classInvitationData = response.data.data;
            }
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },

    // 去邀请按钮
    invite(row) {
      let p0321 = JSON.stringify({
        field: row.fieldCode,
        category: row.categoryCode,
        courseNumber: row.courseNumber,
        courseName: row.courseName,
        dateAndTime: row.dateAndTime,
        formCode: row.formCode,
        classAddress: row.classAddress,
        scheduleStatus: row.scheduleStatus
      });
      sessionStorage.p0321 = p0321;
      // 跳转指定页面
      this.$router.push({
        path: "/views/GreenJacketForum/P0322",
        query: {
          dateAndTime: this.queryForm.dateAndTime,
          courseName: this.queryForm.courseName,
          scheduleStatus: this.queryForm.scheduleStatus,
          currentPageCo: this.currentPageCo,
          totalCo: this.totalCo,
          pageSizeCo: this.pageSizeCo
        }
      });
    },
    // 下载报名二维码按钮
    downloadQrCode(row) {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });

      let url = "/api/classInvitation/getRegQr";
      this.$http
        .post(
          url,
          {
            // 课程编号
            categoryCode: row.fieldCode + row.categoryCode + row.courseNumber,
            dateAndTime: row.dateAndTime,
            // 报名链接
            signUpLink: row.signUpLink
          },
          {
            responseType: "blob"
          }
        )
        .then(response => {
          loading.close();
          // 文件名
          const fileName = row.courseName + row.dateAndTime + ".jpg";
          const fileStream = response.data; // 返回文件流
          const blob = new Blob([fileStream]);
          // 使用dom a 下载图片
          const a = document.createElement("a");
          const href = window.URL.createObjectURL(blob); // 创建下载连接
          a.href = href;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a); // 下载完移除元素
          window.URL.revokeObjectURL(href); // 释放掉blob对象
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 确定延期吗？
    handleExtension(row) {
      this.$confirm(this.$t("p0321.msg1"), this.$t("common.tips"), {
        confirmButtonText: this.$t("common.confirm"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#main-container")
          });
          let url = "/api/classInvitation/updateScheduleStatus";
          this.$http
            .post(url, {
              // 课程编号
              field: row.fieldCode,
              category: row.categoryCode,
              courseNumber: row.courseNumber,
              courseName: row.courseName,
              dateAndTime: row.dateAndTime,
              userId: localStorage.userId,
              scheduleStatus: 2
            })
            .then(response => {
              loading.close();
              this.$message({
                type: "success",
                message: this.$t("p0321.msg2")
              });
              row.scheduleStatus = 2;
            })
            .catch(() => {
              loading.close();
            });
        })
        .catch(() => {});
    },
    // 编辑排课按钮
    editClass(row) {
      let p0321 = JSON.stringify({
        field: row.fieldCode,
        category: row.categoryCode,
        courseNumber: row.courseNumber,
        courseName: row.courseName,
        dateAndTime: row.dateAndTime
      });
      sessionStorage.p0321 = p0321;
      this.$router.push({
        path: "/views/GreenJacketForum/P0324",
        query: {
          dateAndTime: this.queryForm.dateAndTime,
          courseName: this.queryForm.courseName,
          scheduleStatus: this.queryForm.scheduleStatus,
          currentPageCo: this.currentPageCo,
          totalCo: this.totalCo,
          pageSizeCo: this.pageSizeCo
        }
      });
    },
    // 课程编号拼接
    valueFormat(row) {
      return row.fieldCode + row.categoryCode + row.courseNumber;
    }
  },
  mounted() {
    if (this.$route.query.currentPageCo) {
      this.currentPageCo = Number(this.$route.query.currentPageCo);
    }
    if (this.$route.query.totalCo) {
      this.totalCo = Number(this.$route.query.totalCo);
    }
    if (this.$route.query.pageSizeCo) {
      this.pageSizeCo = Number(this.$route.query.pageSizeCo);
    }
    if (this.$route.query.courseName) {
      this.queryForm.courseName = this.$route.query.courseName;
    }
    if (this.$route.query.dateAndTime) {
      this.queryForm.dateAndTime = this.$route.query.dateAndTime;
    }
    if (this.$route.query.scheduleStatus) {
      this.queryForm.scheduleStatus = Number(this.$route.query.scheduleStatus);
    }
    let path = this.$route.path; //先获取路由路径
    this.$router.replace(path); //再跳转路由路径，query参数没带过去，所以被清除了
    this.init(false);
  }
};
</script>

<style lang="scss" scoped>
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/views/GreenJacketForum/P0321.vue